import React from 'react'
import Plot from 'react-plotly.js';
import { Loading, Toggle } from '@sede-enterprise/shell-ds-react-framework';


const AssetMonthlyChart = ({ loading, statisticsData, dataToPlot, layout, selectedSite, stackView, setStackView }) => {

    return (
        <div className='asset-monthly-container' id='asset-monthly-id-1'>
            {selectedSite?.length === 1 && <div className='chart-toggle' id='asset-monthly-id-2'>
                <Toggle size='small' checked={stackView} onChange={() => setStackView((prev) => !prev)} id='asset-monthly-id-3' />
                <p className='data-label' id='asset-monthly-id-4'>Stack View</p>
            </div>
            }
            {
                !loading ? statisticsData && statisticsData?.length > 0 ? <div className='chart-container'> <Plot
                    id='asset-monthly-id-5'
                    className="full-size-chart"
                    data={dataToPlot}
                    layout={layout}
                    useResizeHandler={true}
                    style={{ width: "100%", height: "100%" }}
                />
                </div> : <div className='empty-container' id='asset-monthly-id-6'>
                    <p className='data-value' id='asset-monthly-id-7'>No Data Available</p>
                </div>
                    : <div className='loading-container' id='asset-monthly-id-8' role='status'> <Loading id='asset-monthly-id-9' /> </div>
            }
        </div>
    )
}

export default AssetMonthlyChart